define('pulse',['jquery', 'underscore', 'event-manager', 'lib'], function($, _, eventManager, lib) {
    'use strict';

    var isDisabled = false;
    var hasInit = false;
    var subscribers = [];
    var activeTrackers = [];

    function getObjectBase(type, options) {
        var _options = options || {};
        var contentId = _options.id || generateContentId(type);
        var base = {
            contentId: contentId,
            accessLevel: "Free"
        }

        if (_options.forceFields) {
            base['@id'] = 'sdrn:e24:' + type.toLowerCase() + ':' + contentId;
            base['@type'] = type;
        } else {
            base.id = contentId;
            base.type = type;
        }

        if (_options.override && typeof _options.override === 'object') {
            base = Object.assign({}, base, _options.override);
        }

        return base;
    }

    function getPageUrl() {
        var canonical = lib.$('link[rel="canonical"]');
        if (canonical) {
            return canonical.attr('href');
        }

        var hostname = encodeURIComponent(window.location.hostname);
        var pathname = encodeURIComponent(window.location.pathname);
        return 'https://' + hostname + pathname;
    }

    function getProvider() {
        return {
            type: "Organization",
            id: "e24",
            'spt:engage': "e24",
            productTag: 'e24'
        };
    }

    var listings = ['section', 'keyword', 'finn'];

    function getPageType() {
        var route = lib.getRoute();
        if (route === 'front') {
            return 'Frontpage';
        }

        if (listings.indexOf(route) > -1) {
            return 'Listing';
        }

        if (route === 'article') {
            return 'Article'
        }

        return 'Content';
    }

    function generateContentId(route) {
        if (route === 'Frontpage') {
            return 'front';
        }

        if (route === 'Article') {
            return lib.getArticleId().toString();
        }

        return window.location.pathname;
    }

    function getPageViewOptions(userId) {
        var pulseOptions = {
            type: 'View',
            object: getObjectBase(getPageType()),
            provider: getProvider(),
        };

        if (userId) {
            var realm = 'spid.no';
            pulseOptions.actor = {
                id: userId,
                'spt:userId': 'sdrn:' + realm + ':user:' + userId,
                realm: realm,
                subscriptionName: lib.getSubscriptionName()
            }
        }

        if (!lib.isProduction()) {
            document.cookie = '_pulse2debug=true';
            pulseOptions.deployStage = 'dev';
            pulseOptions.deployTag = 'sdk-dev';
        }

        return pulseOptions;
    }

    function initTracking(userId) {
        if (!activeTrackers.indexOf('tracker') > -1) {
            activeTrackers.push('tracker');
            pulse('init', 'e24', null, null, 'tracker');
        }
        pulse('tracker.newPageView');
        pulse('tracker.update', getPageViewOptions(userId));

        pulse('tracker.require', 'localHistory');
        pulse('tracker.track', 'trackerEvent');
    }

    function startPulse() {
        /**
         *  Pulse tracks every page EXCEPT for articles!
         *  Check out js/e24/article.js (which uses Engage) for article tracking
         **/
        if (!hasInit && !isDisabled) {
            try {
                hasInit = true;
                var _initializePulse = function(userId) {
                    initTracking(userId);

                    subscribers.forEach(function(callback) {
                        callback(pulse);
                    });

                    // Remove autorefresh from url
                    setTimeout(function() {
                        var search = window.location.search;
                        if (!search) {
                            return;
                        }

                        var searchQuery = search.substr(1);
                        var filteredQuery = searchQuery
                            .split('&')
                            .filter(function(part) { return part.split('=')[0] !== 'autorefresh'; })
                            .join('&');

                        if (filteredQuery !== searchQuery) {
                            window.history.replaceState(
                                null,
                                '',
                                window.location.pathname + (filteredQuery ? '?' + filteredQuery : '')
                            );
                        }
                    }, 750);
                };

                // Ensure we get spid id before we initialize Pulse
                var userId = lib.getUserId();
                if (userId) {
                    _initializePulse(userId);
                } else {
                    _initializePulse(null);
                }
            } catch (e) {
                throw e;
            }
        }
    }

    return {
        init: function(disabled) {
            isDisabled = typeof disabled === 'boolean' ? disabled : !!lib.getArticleId();
            startPulse();

            if (!isDisabled) {
                pulse('tracker', function(Tracker) {
                    eventManager.emit('pulseready', Tracker);
                });
            }
        },
        ready: function ready(callback, trackerName) {
            var tracker = trackerName && typeof trackerName === 'string'
                ? trackerName
                : 'tracker';

            // if tracker has not been initialized yet
            if (!activeTrackers.indexOf(tracker) > -1) {
                pulse('init', 'e24', null, null, tracker);
                activeTrackers.push(tracker);

                var options = {
                    provider: getProvider(),
                };

                if (!lib.isProduction()) {
                    options.deployStage = 'dev';
                    options.deployTag = 'sdk-dev';
                }

                pulse(tracker + '.update', options);
            }

            pulse(tracker, callback);
        },
        getObjectBase: getObjectBase,
        getPageType: getPageType,
        getPageUrl: getPageUrl,
        getProvider: getProvider,
    };
});

